export function injectStyleEl(styles) {
	const el = document.createElement('style');
	el.appendChild(document.createTextNode(styles));
	document.head.appendChild(el);
}


// WEBPACK FOOTER //
// ./src/dom.js